// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Axios from 'axios'
import i18n from './i18n'
Vue.config.productionTip = false
Vue.prototype.$axios = Axios
//Axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded'


// firebase
import firebase from "@firebase/app";
import "@firebase/firestore";
import "@firebase/analytics";
import {setLogoAndTitle} from "./util";
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const firebaseConfig = {
  apiKey: "AIzaSyCs_iSie3bnzgVih8_gU1_9lN6yXfE9u-0",
  authDomain: "buzzcast-web.firebaseapp.com",
  projectId: "buzzcast-web",
  storageBucket: "buzzcast-web.appspot.com",
  messagingSenderId: "425744601459",
  appId: "1:425744601459:web:a759f04b7f2317f4f43506",
  measurementId: "G-2DYNLMFL96"
};
firebase.initializeApp(firebaseConfig);
// alias (配置别名方便使用)
Vue.prototype.$analytics = firebase.analytics();



Axios.defaults.baseURL = process.env.baseURL;
Vue.prototype.global_huanjing = process.env;
Vue.prototype.global_apiUrl = process.env.baseURL;//全局接口api
Vue.prototype.global_paypalUrl = process.env.paypalUrl;//paypalUrl
Vue.prototype.login_redirectURI_zh = process.env.login_redirectURI_zh;//登录中专 国内链接
Vue.prototype.login_redirectURI_guowai = process.env.login_redirectURI_guowai;//登录中专 国外链接
Vue.prototype.$globalData = { source: '' }
setLogoAndTitle()


router.beforeEach((to, from, next) => {
  try {
    var href = location.href;
    console.log("beforeEach href: ", href)
    let fromParam = decodeURIComponent(href)
    // 如果链接参数from参数不为空, 则页面重定向到别个一个页面
    // 获取fromParam中[]之间的字符串
    let startIndex = fromParam.indexOf('sd_id')
    let endIndex = fromParam.indexOf('ed_id')

    if (startIndex === -1 || endIndex === -1 || startIndex >= endIndex) {
      next()
    } else {
      let url = fromParam.substring(startIndex + 5, endIndex)
      console.log("beforeEach fromParam: " +url)
      // 如果fromParam中有参数，跳转到fromParam中的地址
      let origin = window.location.origin
      // fromParam中的域名和当前域名一致，则需要拼接参数
      console.log("beforeEach origin: ", origin)
      if(url.startsWith(origin)) {
        console.log("same origin")
        next()
      } else {
        window.location.replace(url)
      }
    }
  } catch (e) {
    next()
  }
})


/* eslint-disable no-new */
window.rootApp =  new Vue({
  el: '#app',
  router,
  store, // Vuex store 已配置但暂不使用
  i18n,
  components: {
    App
  },
  template: '<App/>',
  data: () => {
    return {
      selOneAccount: {
        show: false,
        accountList: [],
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js